<template>
    <impersonation-bar></impersonation-bar>
    <div class="min-h-screen bg-gray-100 lg:flex intake-layout">
        <div class="w-auto flex flex-col aside md:min-w-[584px]">
            <div class="flex-grow-0 px-8 pt-40 pb-24 text-center aside-header">
                <h1 class="mb-4 text-2xl font-bold text-white">Investor Information</h1>
                <h2 class="text-lg font-normal text-gray-20">Invest Beyond the Ordinary™</h2>
            </div>

            <div class="flex justify-center flex-1 px-8 pb-5 aside-body">
                <div class="flex flex-col">
                    <div class="flex-1">
                        <ul class="-mb-8 aside-steps">
                            <li v-for="(step, index) in steps" :key="index" class="aside-step" :class="{
                                'is-completed cursor-pointer': index < page,
                                'is-current': index == page
                            }" @click="goToStep(index)">
                                <div class="relative pb-11">
                                    <span v-show="index < (steps.length-1)" class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-white step-line hidden lg:block"></span>
                                    <div class="relative flex items-center space-x-6">
                                        <div>
                                            <span class="flex items-center justify-center w-8 h-8 bg-black border-2 border-white rounded-full step-circle">
                                                <span v-show="index == page" class="w-3 h-3 rounded-full bg-teal step-dot"></span>
                                                <svg v-show="index < page" class="w-6 h-6 text-black step-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg>
                                            </span>
                                        </div>
                                        <div class="flex-1 min-w-0 step-text">
                                            <div class="text-xs font-semibold text-white step-title" :class="{'!text-teal': index <= page}">{{ step.title }}</div>
                                            <div class="text-sm text-[#9AA6B8] font-normal step-subtitle hidden md:block">{{ step.subtitle }}</div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="px-4 pt-10 pb-10 sm:pt-0">
                        <a href="/logout" class="inline-flex items-center space-x-2 text-white !no-underline font-semibold">
                            <span><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path></svg></span>
                            <span>Logout</span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="hidden w-auto px-8 py-5 text-xs text-left text-white no-underline normal-case lg:w-full lg:flex lg:items-center lg:justify-between aside-footer">
                <div>
                    <p>You must be an accredited member to invest.</p>
                    <p>Read our <a href="https://mammoth.vc/terms/" target="_blank" class="font-bold">Terms</a>, <a href="https://mammoth.vc/privacy-cookie-policy/" target="_blank" class="font-bold">Data Policy and Cookies Policy</a> here.</p>
                </div>
                <div><img class="w-auto h-8" :src="asset('img/logo-white.svg')" alt="Logo"></div>
            </div>
        </div>

        <div class="flex-1 px-10 py-10 bg-white main">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import ImpersonationBar from '@/Parts/ImpersonationBar.vue'
import { onMounted } from 'vue'
import onIdle from '@/Composables/idle'

export default {
    components: {
        ImpersonationBar
    },
    props: {
        page: {
            type: Number,
            default: 0
        }
    },
    emit: ['goto'],
    setup(props, { emit }){
        onMounted(() => {
            onIdle()
        })

        function goToStep(index){
            if (props.page == 5) {
                return false
            }

            if (index < props.page) {
                emit('goto', index)
            }
        }

        return {
            goToStep
        }
    },
    computed: {
        steps(){
            return [{
                title: "Complete Your Profile",
                subtitle: "Fill out the required fields.",
                form: 'profile-form',
            }, {
                title: "Confirm Suitability",
                subtitle: "Gain access to funds that fit you.",
                form: 'suitability-form',
            }, {
                title: "Invest",
                subtitle: "Input the amount of money you want to invest.",
                form: 'invest-form',
            }, {
                title: "Investor Verification",
                subtitle: "Verify your status.",
                form: 'verification-form',
            },
            /* {
                title: "Customer Agreement",
                subtitle: "Please read this carefully before clicking Next",
                form: 'agreement-form',
            }, */
            {
                title: "Review Subscription",
                subtitle: "Review your investment.",
                form: 'review-form',
            }, {
                title: "Confirm Investment",
                subtitle: "Confirm your investment.",
                form: 'confirmation-form',
            }];
        }
    }
}
</script>
